export default "__VITE_ASSET__DIdGUjhd__"